export function getLocalObj(key: string, default_value: any) {
    const value = localStorage.getItem(key);
    if (value && value !== "undefined") {
        return JSON.parse(value);
    } else {
        return default_value;
    }
}

export function setLocalObj(key: string, obj: any) {
    if (obj) {
        const value = JSON.stringify(obj);
        localStorage.setItem(key, value);
    }else {
        cleanLocalObj(key)
    }
}

export function cleanLocalObj(key) {
    localStorage.removeItem(key)
}
